import React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as S from './styles';

// type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root> & {

// } Comentado por estar vazio, usar caso necesssário

export function Popover ({ children, ...props }: /* PopoverProps */ React.ComponentProps<typeof PopoverPrimitive.Root>){
  return (
    <PopoverPrimitive.Root {...props}>
      {children}
    </PopoverPrimitive.Root>
  )
}


// type PopoverContentProps = PopoverPrimitive.PopoverContentProps &
//   React.ComponentProps<typeof S.PopoverPrimitiveContent> & {
// } Comentado por estar vazio, usar caso necessário

export function PopoverContent ({ children, ...props }: /* PopoverContentProps */ PopoverPrimitive.PopoverContentProps & React.ComponentProps<typeof S.PopoverPrimitiveContent>) {
  function handleOpenAutoFocus (event: Event){
    event.preventDefault();
  }
  return <S.PopoverPrimitiveContent onOpenAutoFocus={handleOpenAutoFocus} {...props}> {children}</S.PopoverPrimitiveContent>
}

export const PopoverTrigger = PopoverPrimitive.Trigger;
PopoverTrigger.displayName = 'PopoverTrigger';

